// Module
var code = `<div class="modal-dialog modal-lg" role="document" id="transformationScriptSyntaxDialog">
    <div class="modal-content">
       <div class="modal-body">
           <button type="button" class="close" data-dismiss="modal" aria-label="Close"><i class="icon-cancel"></i></button>
           <div data-bind="if: etlType() === 'Raven'">
               <h3 class="margin-bottom margin-top">Sample RavenDB ETL Transformation Scripts</h3>
               <div data-bind="foreach: \$data.constructor.ravenEtlSamples">
                   <div class="margin-top" data-bind="text: title"></div>
                   <pre class="margin-bottom copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, title)"><i class="icon-copy"></i></a><span data-bind="html: html"></span></pre>
               </div>
            </div>
           <div data-bind="if: etlType() === 'Sql'" class="copy-area">
               <h3 class="margin-bottom margin-top">Sample SQL ETL Transformation Script</h3>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: copySample"><i class="icon-copy"></i></a><span data-bind="html: sqlEtlSampleHtml"></span></pre>
               </div>
           </div>
           <div data-bind="if: etlType() === 'Snowflake'" class="copy-area">
               <h3 class="margin-bottom margin-top">Sample Snowflake ETL Transformation Script</h3>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: copySample"><i class="icon-copy"></i></a><span data-bind="html: snowflakeEtlSampleHtml"></span></pre>
               </div>
           </div>
           <div data-bind="if: etlType() === 'ElasticSearch'" class="copy-area">
               <h3 class="margin-bottom margin-top">Sample Elasticsearch ETL Transformation Script</h3>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: copySample"><i class="icon-copy"></i></a><span data-bind="html: elasticSearchEtlSampleHtml"></span></pre>
               </div>
           </div>
           <div data-bind="if: etlType() === 'Olap'" class="copy-area">
               <h3 class="margin-bottom margin-top">Sample OLAP ETL Transformation Scripts</h3>
               <div>Transform with Partitions</div>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, 'olapEtlSamplePartition')"><i class="icon-copy"></i></a><span data-bind="html: olapEtlSamplePartitionHtml"></span></pre>
               </div>
               <div>Transform without Partitions</div>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, 'olapEtlSampleNoPartition')"><i class="icon-copy"></i></a><span data-bind="html: olapEtlSampleNoPartitionHtml"></span></pre>
               </div>
               <div>Partition with Key</div>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, 'olapEtlSampleKey')"><i class="icon-copy"></i></a><span data-bind="html: olapEtlSampleKeyHtml"></span></pre>
               </div>
               <div>Partition with Custom Partition</div>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, 'olapEtlSampleCustomPartition')"><i class="icon-copy"></i></a><span data-bind="html: olapEtlSampleCustomPartitionHtml"></span></pre>
               </div>
           </div>
           <div data-bind="if: etlType() === 'Kafka'" class="copy-area">
               <h3 class="margin-bottom margin-top">Sample Kafka ETL Transformation Script</h3>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: copySample"><i class="icon-copy"></i></a><span data-bind="html: kafkaEtlSampleHtml"></span></pre>
               </div>
           </div>
           <div data-bind="if: etlType() === 'RabbitMQ'" class="copy-area">
               <h3 class="margin-bottom margin-top">Sample RabbitMQ ETL Transformation Script</h3>
               <div>Example</div>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: copySample"><i class="icon-copy"></i></a><span data-bind="html: rabbitMqEtlSampleHtml"></span></pre>
               </div>
               <table class="table table-striped table-condensed">
                   <thead>
                   </thead>
                   <tbody>
                   <tr>
                       <th><strong><em>loadTo</em> Option</strong></th>
                       <th><strong>Target Exchange</strong></th>
                       <th><strong>Routing Key</strong></th>
                   </tr>
                   <tr>
                       <td><code>loadToUsers({ Name: 'Bob' })</code></td>
                       <td>Users</td>
                       <td class="text-muted">empty (default)</td>
                   </tr>
                   <tr>
                       <td><code>loadToUsers({ Name: 'Bob' }, 'admin')</code></td>
                       <td>Users</td>
                       <td>admin</td>
                   </tr>
                   <tr>
                       <td>
                           <code>loadToUsers({ Name: 'Bob' }, {<br>
                               <span class="margin-left">Id: ...,</span><br>
                               <span class="margin-left">Source: ...,</span><br>
                               <span class="margin-left">Type: ...</span><br> })
                           </code>
                       </td>
                       <td>Users</td>
                       <td class="text-muted">empty (default)</td>
                   </tr>
                   <tr>
                       <td>
                           <code>loadToUsers({ Name: 'Bob' }, 'admin', {<br>
                               <span class="margin-left">Type: ...,</span><br> })
                           </code>
                       </td>
                       <td>Users</td>
                       <td>admin</td>
                   </tr>
                   <tr>
                       <td><code>loadTo('', { Name: 'Bob' }, 'users-queue')</code></td>
                       <td class="text-muted">empty (default)</td>
                       <td>users-queue</td>
                   </tr>
                   </tbody>
               </table>
           </div>
           <div data-bind="if: etlType() === 'AzureQueueStorage'" class="copy-area">
               <h3 class="margin-bottom margin-top">Sample Azure Queue Storage ETL Transformation Script</h3>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: copySample"><i class="icon-copy"></i></a><span data-bind="html: azureQueueStorageEtlSampleHtml"></span></pre>
               </div>
           </div>
           <div data-bind="if: etlType() === 'AmazonSqs'" class="copy-area">
               <h3 class="margin-bottom margin-top">Sample Amazon SQS ETL Transformation Script</h3>
               <div class="margin-bottom">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: copySample"><i class="icon-copy"></i></a><span data-bind="html: amazonSqsEtlSampleHtml"></span></pre>
               </div>
           </div>
           <div data-bind="if: etlType() === 'EmbeddingsGeneration'">
               <h3 class="margin-bottom margin-top">Sample Embeddings Generation Script</h3>
               <div>Text</div>
               <div class="margin-bottom copy-area">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, 'embeddingsGenerationSampleText')"><i class="icon-copy"></i></a><span data-bind="html: embeddingsGenerationSampleTextHighlighted"></span></pre>
               </div>
               <div>Markdown</div>
               <div class="margin-bottom copy-area">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, 'embeddingsGenerationSampleMarkdown')"><i class="icon-copy"></i></a><span data-bind="html: embeddingsGenerationSampleMarkdownHighlighted"></span></pre>
               </div>
               <div>HTML</div>
               <div class="margin-bottom copy-area">
                   <pre class="copy-area"><a href="#" class="copy-button-hidden margin-right-xs" title="Copy code sample" data-bind="click: _.partial(\$root.copySample, 'embeddingsGenerationSampleHtml')"><i class="icon-copy"></i></a><span data-bind="html: embeddingsGenerationSampleHtmlHighlighted"></span></pre>
               </div>
           </div>
       </div>
    </div>
</div>
`;
// Exports
export default code;